import { AXIOSWAYS, ApiInfo } from './server';
import Wx from 'weixin-js-sdk';
import CryptoJS from 'crypto-js';
import videojs from 'video.js';
import 'video.js/dist/video-js.css';
import zhCN from 'video.js/dist/lang/zh-CN.json';
// 使用 addLanguage 注册中文
videojs.addLanguage('zh-CN', zhCN);

const NEWS_MAIN_DOWNLOAD_BTN = 'NewsMainDownloadButton';
if (!videojs.getComponent(NEWS_MAIN_DOWNLOAD_BTN)) {
    const VjsButton = videojs.getComponent('Button');
    class NewsMainDownloadButton extends VjsButton {
        constructor(player, options) {
            super(player, options);
            this.controlText('下载');
            this.addClass('vjs-news-main-download');
            var label = document.createElement('span');
            label.className = 'vjs-news-main-download-label';
            label.setAttribute('aria-hidden', 'true');
            label.textContent = '下载';
            label.style.fontSize = '0.75rem';
            label.style.lineHeight = '1';
            label.style.padding = '0 0.2em';
            label.style.pointerEvents = 'none';
            this.el().appendChild(label);
            var ph = this.el().querySelector('.vjs-icon-placeholder');
            if (ph) {
                ph.style.display = 'none';
            }
        }
        handleClick() {
            const player = this.player();
            let src = player.currentSrc();
            if (!src && typeof player.src === 'function') {
                const raw = player.src();
                src = typeof raw === 'string' ? raw : (raw && raw.src);
            }
            if (!src) return;
            const opts = player.options();
            let name = (opts.downloadFileName || 'video').replace(/[/\\?%*:|"<>]/g, '-').trim() || 'video';
            if (!/\.(mp4|webm|ogg|mov)$/i.test(name)) {
                name += '.mp4';
            }
            const a = document.createElement('a');
            a.href = src;
            a.download = name;
            a.target = '_blank';
            a.rel = 'noopener noreferrer';
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
        }
    }
    videojs.registerComponent(NEWS_MAIN_DOWNLOAD_BTN, NewsMainDownloadButton);
}

function contentVideoDownloadBaseName(src) {
    if (!src || typeof src !== 'string') {
        return 'video';
    }
    try {
        var path = src.split('?')[0].split('#')[0];
        var last = path.split('/').pop();
        if (last) {
            last = decodeURIComponent(last);
            last = last.replace(/[/\\?%*:|"<>]/g, '-').trim();
            if (last) {
                return last.replace(/\.(mp4|webm|ogg|mov)$/i, '') || 'video';
            }
        }
    } catch (e) {
        /* ignore */
    }
    return 'video';
}

export default {
    Attribute: {
        UA: window.navigator.userAgent,
        // 判断是否是微信
        isWeixin () {
            var ua = this.UA
            if (/MicroMessenger/i.test(ua)) {
                return true
            }
            return false
        },
        // 判断是否是QQ
        isQQ () {
            var ua = this.UA
            if (/QQ\//.test(ua)) {
                return true
            }
            return false
        },
        // 判断是否是Android
        isAndroid () {
            var ua = this.UA
            if (/android/i.test(ua)) {
                return true
            }
            return false
        },
        // 判断是否是ios
		isIOS (){
			var ua = this.UA;
		    if (/ios/i.test(ua) || /iphone/i.test(ua) || /ipad/i.test(ua) || /ipod/i.test(ua)) {
		       return true;
		    }
		    return false;
        },
        isIosMQQBrowser () {
            var ua = this.UA;
            if (this.isIOS() && /MQQBrowser/.test(ua)) {
                return true;
            }
            return false;
        },
        // 判断是否是手机
        isMb() {
            var ua = this.UA
            if (/Android|webOS|iPhone|iPod|BlackBerry|Windows Phone|Harmony/i.test(ua)) {
                return true
            }
            return false
        },
        isIpad () {
            var ua = this.UA
            if (/ipad/i.test(ua)) {
                return true;
             }
             return false;
        },
        isMiniprogram(){
            var ua = navigator.userAgent.toLowerCase();
            return new Promise((resolve) => {
                if(ua.match(/MicroMessenger/i)=="micromessenger") {
                    //ios的ua中无miniProgram，但都有MicroMessenger（表示是微信浏览器）
                    Wx.miniProgram.getEnv((res) => {
                        if (res.miniprogram) {
                            resolve(true);
                        } else {
                            resolve(false)
                        }
                    })

                }else{
                    resolve(false)
                }
            })
            
        }
    },
    // 分享
    // pageShare () {
    //     Api.getHomeShare({}).then((data) => {
    //         data && data.share && this.onshare({
    //             shareTitle: data.share.shareTitle,
    //             shareBrief: data.share.shareBrief,
    //             shareImg: data.share.shareImg,
    //             shareUrl: window.location.href
    //         })
    //     })
    // },
    // 分享
    onShare (obj) {
        const shareDate = {
            title: obj.shareTitle || '四川互联网举报辟谣平台',
            desc: obj.shareBrief || '四川互联网举报辟谣平台',
            imgUrl: obj.shareImg || 'https://wapcdn.thecover.cn/cdn/cover_pc/static/img/2x/piyao_share_logo.png?version=v1',
            link: obj.shareUrl || window.location.href
        }
        // 微信分享
        if (this.Attribute.isWeixin()) {
            this.setWeChatConf().then(() => {
                this.wxOnshare(shareDate)
            })
        // qq分享
        } 
        else if (this.Attribute.isQQ()) {
            if (window.mqq && window.mqq.data && window.mqq.data.setShareInfo) { // 手机qq内置浏览器
                window.mqq.data.setShareInfo({
                    title: shareDate.title,
                    share_url: shareDate.link,
                    image_url: shareDate.imgUrl,
                    desc: shareDate.desc
                })
            } else {
                this.loadjs('https://open.mobile.qq.com/sdk/qqapi.js?_bid=152').then(() => { // qq浏览器
                    window.mqq.data.setShareInfo({
                        title: shareDate.title,
                        share_url: shareDate.link,
                        image_url: shareDate.imgUrl,
                        desc: shareDate.desc
                    })
                })
            }
        }
    },
    // 微信配置
    setWeChatConf () {
        return new Promise((resolve, reject) => {
            AXIOSWAYS.post(
                'https://piyao-api.thecover.cn/wap/counterRumour/weixin/getConf',
                {
                    url: window.location.href
                }
            ).then(data => {
                const D = data
                Wx.config({
                    debug: false,
                    appId: D.appId,
                    timestamp: D.timestamp,
                    nonceStr: D.nonceStr,
                    signature: D.signature,
                    jsApiList: [
                        'onMenuShareTimeline',
                        'onMenuShareAppMessage',
                        'onMenuShareQQ',
                        'onMenuShareWeibo',
                        'onMenuShareQZone',
                        'previewImage'
                    ]
                })
                resolve()
            }).catch((err) => {
                reject(err)
            })
        })
    },
    // 微信分享
    wxOnshare (obj) {
        Wx.ready(() => {
            // 分享到朋友圈
            Wx.onMenuShareTimeline(obj)
            // 分享给朋友
            Wx.onMenuShareAppMessage(obj)
            // 分享到QQ
            Wx.onMenuShareQQ(obj)
            // 分享到腾讯微博
            Wx.onMenuShareWeibo(obj)
            // 分享到QQ空间
            Wx.onMenuShareQZone(obj)
        })
    },
    // 动态加载js
    loadjs (src) {
        return new Promise((resolve, reject) => {
            const scriptNode = document.createElement('script')
            scriptNode.setAttribute('type', 'text/javascript')
            scriptNode.setAttribute('src', src)
            document.body.appendChild(scriptNode)
            // IE 判断
            if (scriptNode.readyState) {
                scriptNode.onreadystatechange = () => {
                    if (scriptNode.readyState === 'complete' || scriptNode.readyState === 'loaded') {
                        resolve()
                    }
                }
            } else {
                scriptNode.onload = () => {
                    resolve()
                }
            }
        })
    },
    loadScroll(height, fn) {
        // height-判定的高度 fn-执行的回调函数
        window.addEventListener('scroll', function() {
            if(Math.ceil((document.body.scrollTop || document.documentElement.scrollTop))
              + (window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight)
              >= (document.documentElement.scrollHeight || document.body.scrollHeight) - height
            ) {
                fn();
            }
        }, false)
    },
    initFontSize () {
        if(this.Attribute.isMb()) {
            return;
        }
        const screenWidth = document.documentElement.clientWidth;
        const fontRatio = 1480 / 16;
        document.querySelector('html').style.fontSize = screenWidth / fontRatio + 'px';
    },
    watchFontSize () {
        if(this.Attribute.isMb()) {
            return;
        }
        //是否在滚动
        var hasScrolled = false;
        //定时器
        var scrollTimer = null;
        // 用于记录Ctrl键是否被按下
        var isCtrlPressed = false;
        // 用于记录+-键是否被按下
        var isAddOrMinusPressed = false;
        //+ -号key keyCode被弃用
        var keyList =['+','-','=','_']
        
        window.addEventListener('resize', (event) => {
            if(hasScrolled || isAddOrMinusPressed) return
            this.initFontSize();
        })
        // 监听键盘按下事件
        document.addEventListener("keydown", function(event) {
            if (event.key === "Control") {
                isCtrlPressed = true;
            }
            if (keyList.indexOf(event.key) > -1 && isCtrlPressed) {
                isAddOrMinusPressed = true
            }
        });

        // 监听键盘松开事件
        document.addEventListener("keyup", function(event) {
            if (event.key === "Control") {
                isCtrlPressed = false;
            }
            if (keyList.indexOf(event.key) > -1) {
                isAddOrMinusPressed = false
            }
        });
        // 监听滚轮事件
        window.addEventListener("wheel", function(event) {
            if (!isCtrlPressed) return
            // 在滚轮事件触发时执行操作
            // 滚轮事件触发时
            hasScrolled = true;
            clearTimeout(scrollTimer);
            scrollTimer = setTimeout(function() {
                if (hasScrolled) {
                    // 滚轮事件结束后执行的操作
                    hasScrolled = false
                    clearTimeout(scrollTimer);
                }
            }, 250);
        });
    },
    // 给id加密解密
    Base64: {
        // private property
        _keyStr: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=",

        // public method for encoding
        encode: function (input) {
            let output = "";
            let chr1, chr2, chr3, enc1, enc2, enc3, enc4;
            let i = 0;

            input = this._utf8_encode(input);

            while (i < input.length) {

                chr1 = input.charCodeAt(i++);
                chr2 = input.charCodeAt(i++);
                chr3 = input.charCodeAt(i++);

                enc1 = chr1 >> 2;
                enc2 = ((chr1 & 3) << 4) | (chr2 >> 4);
                enc3 = ((chr2 & 15) << 2) | (chr3 >> 6);
                enc4 = chr3 & 63;

                if (isNaN(chr2)) {
                    enc3 = enc4 = 64;
                } else if (isNaN(chr3)) {
                    enc4 = 64;
                }

                output = output +
                    this._keyStr.charAt(enc1) + this._keyStr.charAt(enc2) +
                    this._keyStr.charAt(enc3) + this._keyStr.charAt(enc4);

            }

            return output;
        },

        // public method for decoding
        decode: function (input) {
            let output = "";
            let chr1, chr2, chr3;
            let enc1, enc2, enc3, enc4;
            let i = 0;

            input = input.replace(/[^A-Za-z0-9\+\/\=]/g, "");

            while (i < input.length) {

                enc1 = this._keyStr.indexOf(input.charAt(i++));
                enc2 = this._keyStr.indexOf(input.charAt(i++));
                enc3 = this._keyStr.indexOf(input.charAt(i++));
                enc4 = this._keyStr.indexOf(input.charAt(i++));

                chr1 = (enc1 << 2) | (enc2 >> 4);
                chr2 = ((enc2 & 15) << 4) | (enc3 >> 2);
                chr3 = ((enc3 & 3) << 6) | enc4;

                output = output + String.fromCharCode(chr1);

                if (enc3 != 64) {
                    output = output + String.fromCharCode(chr2);
                }
                if (enc4 != 64) {
                    output = output + String.fromCharCode(chr3);
                }

            }

            output = this._utf8_decode(output);

            if(!/^\d+$/.test(output)) {
                return ''
            }

            return output;

        },

        // private method for UTF-8 encoding
        _utf8_encode: function (string) {
            string = String(string);
            string = string.replace(/\r\n/g, "\n");
            let utftext = "";

            for (let n = 0; n < string.length; n++) {

                const c = string.charCodeAt(n);

                if (c < 128) {
                    utftext += String.fromCharCode(c);
                } else if ((c > 127) && (c < 2048)) {
                    utftext += String.fromCharCode((c >> 6) | 192);
                    utftext += String.fromCharCode((c & 63) | 128);
                } else {
                    utftext += String.fromCharCode((c >> 12) | 224);
                    utftext += String.fromCharCode(((c >> 6) & 63) | 128);
                    utftext += String.fromCharCode((c & 63) | 128);
                }

            }

            return utftext;
        },

        // private method for UTF-8 decoding
        _utf8_decode: function (utftext) {
            let string = "";
            let i = 0;
            let c = 0;
            let c1 = 0;
            let c2 = 0;
            let c3 = 0;

            while (i < utftext.length) {

                c = utftext.charCodeAt(i);

                if (c < 128) {
                    string += String.fromCharCode(c);
                    i++;
                } else if ((c > 191) && (c < 224)) {
                    c2 = utftext.charCodeAt(i + 1);
                    string += String.fromCharCode(((c & 31) << 6) | (c2 & 63));
                    i += 2;
                } else {
                    c2 = utftext.charCodeAt(i + 1);
                    c3 = utftext.charCodeAt(i + 2);
                    string += String.fromCharCode(((c & 15) << 12) | ((c2 & 63) << 6) | (c3 & 63));
                    i += 3;
                }

            }

            return string;
        }
    },
    encrypt(data) {
      const key = CryptoJS.enc.Utf8.parse('less-code-log-en');
      const srcs = CryptoJS.enc.Utf8.parse(data);
      const encrypted = CryptoJS.AES.encrypt(srcs, key, {
          mode: CryptoJS.mode.ECB,
          padding: CryptoJS.pad.Pkcs7
      });
      return encrypted.toString();
    },

    decodeBase64ToUtf8: function (base64Str) {
        if (!base64Str) {
            return base64Str
        }
        try {
            let normalized = String(base64Str).replace(/[\r\n\s]/g, '').replace(/-/g, '+').replace(/_/g, '/')
            var padding = normalized.length % 4
            if (padding) {
                normalized += '='.repeat(4 - padding)
            }

            var binary = window.atob(normalized)
            if (typeof TextDecoder !== 'undefined') {
                var bytes = Uint8Array.from(binary, ch => ch.charCodeAt(0))
                return new TextDecoder('utf-8').decode(bytes)
            }

            var percentEncoded = Array.prototype.map.call(binary, ch => {
                return '%' + ('00' + ch.charCodeAt(0).toString(16)).slice(-2)
            }).join('')
            return decodeURIComponent(percentEncoded)
        } catch (e) {
            return base64Str
        }
    },
    initContentVideo: function () {
        var _this = this;
        try {
            var videos = $('.news-wrapper video, .content-wrapper video');
            console.log('videos::',videos.length)
            $.each(videos, function (idx, node) {
                if (node.src) {
                    node.className = node.className + ' video-js vjs-default-skin vjs-big-play-centered vjs-progress-holder'
                    var player = videojs(node, {
                        language: 'zh-CN',
                        controls: true,
                        playbackRates: [0.25, 0.5, 0.75, 1, 1.25, 1.5, 1.75, 2],
                        sources: [{
                            src: node.src
                        },
                        {
                            src: node.src,
                            type: 'video/mp4'
                        }]
                    })
                    // player.ready(function () {

                    //     var container = player.el();
                    //     var viewportH = (window.visualViewport && window.visualViewport.height)
                    //         ? window.visualViewport.height
                    //         : window.innerHeight;
                    //     var isMb = _this.Attribute && typeof _this.Attribute.isMb === 'function' && _this.Attribute.isMb();
                    //     var maxContainerH = Math.floor(viewportH * (isMb ? 0.62 : 0.88));

                    //     function setContentVideoBoxHeight(natW, natH) {
                    //         if (!natW || !natH) {
                    //             return;
                    //         }
                    //         var cw = container.clientWidth || container.offsetWidth || $(container).width() || 0;
                    //         if (!cw) {
                    //             return;
                    //         }
                    //         var rawH = natH * cw / natW;
                    //         var h = Math.min(Math.max(Math.floor(rawH), 1), maxContainerH);
                    //         container.style.height = h + 'px';
                    //         var video = container.querySelector('video');
                    //         if (video) {
                    //             video.style.objectFit = 'contain';
                    //         }
                    //     }

                    //     var posterImg = new Image();

                    //     // 1. 设置海报高度（限制最大高度，避免部分手机竖屏海报把容器撑出屏外）
                    //     posterImg.onload = function () {
                    //         setContentVideoBoxHeight(posterImg.width, posterImg.height);
                    //     };
                    //     posterImg.src = player.poster();

                    //     // 2. 播放时切换到视频高度（同样限制最大高度）
                    //     player.on('play', function () {
                    //         var video = player.el().querySelector('video');
                    //         if (video.videoHeight && video.videoWidth) {
                    //             setContentVideoBoxHeight(video.videoWidth, video.videoHeight);
                    //         } else {
                    //             player.one('loadedmetadata', function () {
                    //                 var v = player.el().querySelector('video');
                    //                 if (v && v.videoWidth && v.videoHeight) {
                    //                     setContentVideoBoxHeight(v.videoWidth, v.videoHeight);
                    //                 }
                    //             });
                    //         }
                    //     });
                    // })
                
                    player.ready(function () {
                        var container = player.el();
                        var w = $(container).width()
                        var posterImg = new Image();

                        // 1. 设置海报高度
                        posterImg.onload = function () {

                            console.log('这里是初始化视频：',posterImg.height, w, posterImg.width)
                            container.style.height = (posterImg.height * w / posterImg.width) + 'px';
                        };
                        posterImg.src = player.poster();

                        // 2. 播放时切换到视频高度
                        player.on('play', function () {
                            var video = player.el().querySelector('video');
                            if (video.videoHeight) {
                                container.style.height = (video.videoHeight * w / video.videoWidth) + 'px';
                            } else {
                                player.one('loadedmetadata', function () {
                                    container.style.height = (video.videoHeight * w / video.videoWidth) + 'px';
                                });
                            }
                        });
                    })

                    var tagsInfo = _this.decodeBase64ToUtf8(node.dataset.videoTags)
                    if (tagsInfo !== undefined) {
                        var jsonTags = JSON.parse(tagsInfo)
                        let htmlStr = ''
                        if (jsonTags && jsonTags.videoTagRelateList && jsonTags.videoTagRelateList.length > 0) {
                            var tagList = jsonTags.videoTagRelateList.filter(function (item) {
                                return item.id != -1 && item.tagId != -1
                            })
                            if (tagList.length) {
                                htmlStr = '<div class="video_ai_tag_box">'
                                for (let i = 0; i < tagList.length; i++) {
                                    var tag = tagList[i]
                                    if (i === 0) {
                                        htmlStr += `<div class="ai_tips_box"> <div class="ai_tags_tips">${tag.tagName}</div> ${tagList.length > 1 ? '<div class="ai_tags_arrow"></div>' : ''} </div> <div class="ai_tags_info hide">`
                                    } else {
                                        htmlStr += `<div class="ai_tag">${tag.tagName}</div>`
                                    }
                                }
                                htmlStr += '</div></div>'
                            }
                        }
                        if (htmlStr) {
                            var playerContainer = this.closest('.video-js') || this.parentElement
                            var controlBar = playerContainer ? playerContainer.querySelector('.vjs-control-bar') : null
                            var insertTarget = controlBar ? controlBar.parentElement : null
                            if (insertTarget) {
                                var $insertTarget = $(insertTarget)
                                $insertTarget.find('.video_ai_tag_box').remove()
                                $insertTarget.append(htmlStr)
                            }
                        }
                    }
                }
            });

            $('.video_ai_tag_box').on('click', function (e) {
                e.preventDefault()
                e.stopPropagation()
                const $parentDiv = $(this)
                const $tagsInfo = $parentDiv.find('.ai_tags_info')
                const $tagsArrow = $parentDiv.find('.ai_tags_arrow')
                if (!$tagsInfo.length) {
                    return
                }
                $tagsArrow.css({
                    'transition': 'transform 0.2s ease',
                    'transform-origin': '50% 50%'
                })
                if ($tagsInfo.hasClass('hide')) {
                    $tagsInfo.removeClass('hide')
                    $tagsInfo.css('display', 'block')
                    $tagsArrow.css('transform', 'rotate(180deg)')

                } else {
                    $tagsInfo.addClass('hide')
                    $tagsInfo.css('display', 'none')
                    $tagsArrow.css('transform', 'rotate(0deg)')
                }
                setTimeout(function () {
                    $parentDiv.scrollTop($parentDiv.scrollHeight)
                }, 0)
            })
        } catch (e) { }

    },
}